import { useEffect, useRef } from "react";

const useUnmounted = () => {
  const unmounted = useRef(false);
  useEffect(() => {
    return () => {
      unmounted.current = true;
    };
  }, []);

  return unmounted;
};

export { useUnmounted };
